import React, {useCallback} from "react";
import {SortDirection} from "../schema";
import cn from "classnames";
import sortButtonClasses from "./sortbutton.module.css";
import classes from "./sortbuttonsingle.module.css";
import {NoSortIcon, SortIcon} from "./icons";

type SortButtonProps = {
  setSort: React.Dispatch<React.SetStateAction<SortDirection | null>>;
  isActive: boolean;
  direction: SortDirection.ASC | SortDirection.DESC  | null;
};

const SortButtonSingle = ({setSort, isActive, direction}: SortButtonProps) => {
  const handleClick = useCallback(() => {
    setSort(prev =>
      prev === SortDirection.ASC ? SortDirection.DESC :
        prev === SortDirection.DESC ? null :
          SortDirection.ASC
    )
  }, [setSort]);
  return(
    <button
      type="button"
      onClick={handleClick}
      className={cn(
        direction === SortDirection.ASC ? sortButtonClasses.rotate : "",
        isActive && sortButtonClasses.active,
        !isActive && sortButtonClasses.notSelect,
        classes.sortButton
      )}
    >
      {isActive ?<SortIcon /> : <NoSortIcon />}
    </button>
  );
}

export default SortButtonSingle
